import React from 'react'
import { DEFAULT_HAGER_BRIDGE_PERMISSIONS } from '../hooks/default-hager-bridge-permissions'
import { HagerBridgePermissions } from './hager-bridge-permissions'

export interface HagerBridgePermissionContextValue {
  permissions: HagerBridgePermissions
}

export const HagerBridgePermissionContext = React.createContext<HagerBridgePermissionContextValue>({
  permissions: DEFAULT_HAGER_BRIDGE_PERMISSIONS,
})
